import React, { Component } from 'react';
import { facultyData } from '../facultyData';
interface StandardTemplateProps {
  data: typeof facultyData;
  showQR: boolean;
  showPageNumbers: boolean;
}
export function StandardTemplate({
  data,
  showQR,
  showPageNumbers
}: StandardTemplateProps) {
  return <div className="font-serif-cv text-slate-900 leading-relaxed max-w-3xl mx-auto" data-id="element-166">
      {/* Header */}
      <div className="text-center mb-10" data-id="element-167">
        <h1 className="text-4xl font-bold text-slate-900 mb-2" data-id="element-168">
          {data.personalInfo.fullName}
        </h1>
        <p className="text-lg text-slate-600 mb-4" data-id="element-169">
          {data.personalInfo.designation} • {data.personalInfo.department}
        </p>
        <div className="flex justify-center items-center space-x-4 text-sm text-slate-500" data-id="element-170">
          <span data-id="element-171">{data.personalInfo.email}</span>
          <span data-id="element-172">|</span>
          <span data-id="element-173">{data.personalInfo.phone}</span>
          <span data-id="element-174">|</span>
          <span data-id="element-175">{data.personalInfo.officeAddress}</span>
        </div>
      </div>

      <div className="space-y-8" data-id="element-176">
        <section data-id="element-177">
          <h2 className="text-sm font-bold text-slate-400 uppercase tracking-widest mb-4 text-center" data-id="element-178">
            Professional Summary
          </h2>
          <p className="text-slate-700 text-center max-w-2xl mx-auto" data-id="element-179">
            {data.biography}
          </p>
        </section>

        <section data-id="element-180">
          <h2 className="text-sm font-bold text-slate-400 uppercase tracking-widest mb-4 text-center" data-id="element-181">
            Experience
          </h2>
          <div className="space-y-6" data-id="element-182">
            {data.experience.map((exp, i) => <div key={i} className="flex flex-col md:flex-row md:justify-between" data-id="element-183">
                <div className="md:w-3/4" data-id="element-184">
                  <h3 className="font-bold text-slate-900" data-id="element-185">{exp.role}</h3>
                  <div className="text-slate-600" data-id="element-186">{exp.organization}</div>
                  <p className="text-sm text-slate-700 mt-2" data-id="element-187">
                    {exp.description}
                  </p>
                </div>
                <div className="md:w-1/4 md:text-right text-sm font-medium text-slate-500 mt-1 md:mt-0" data-id="element-188">
                  {exp.period}
                </div>
              </div>)}
          </div>
        </section>

        <section data-id="element-189">
          <h2 className="text-sm font-bold text-slate-400 uppercase tracking-widest mb-4 text-center" data-id="element-190">
            Education
          </h2>
          <div className="space-y-4" data-id="element-191">
            {data.education.map((edu, i) => <div key={i} className="flex flex-col md:flex-row md:justify-between" data-id="element-192">
                <div data-id="element-193">
                  <h3 className="font-bold text-slate-900" data-id="element-194">{edu.degree}</h3>
                  <div className="text-slate-600" data-id="element-195">{edu.institution}</div>
                </div>
                <div className="text-sm font-medium text-slate-500 mt-1 md:mt-0" data-id="element-196">
                  {edu.year}
                </div>
              </div>)}
          </div>
        </section>

        <section data-id="element-197">
          <h2 className="text-sm font-bold text-slate-400 uppercase tracking-widest mb-4 text-center" data-id="element-198">
            Key Publications
          </h2>
          <ul className="list-disc list-outside ml-4 space-y-2 text-sm text-slate-700" data-id="element-199">
            {data.publications.slice(0, 4).map((pub, i) => <li key={i} className="pl-2" data-id="element-200">
                <span className="font-medium" data-id="element-201">{pub.authors}</span> ({pub.year}).
                "{pub.title}". <span className="italic" data-id="element-202">{pub.venue}</span>.
              </li>)}
          </ul>
        </section>

        <section data-id="element-203">
          <h2 className="text-sm font-bold text-slate-400 uppercase tracking-widest mb-4 text-center" data-id="element-204">
            Skills & Certifications
          </h2>
          <div className="grid grid-cols-2 gap-6 text-sm" data-id="element-205">
            <div data-id="element-206">
              <div className="font-bold text-slate-800 mb-2" data-id="element-207">
                Technical Skills
              </div>
              <p className="text-slate-600" data-id="element-208">
                {data.skills.find(s => s.category === 'Technical')?.items.join(', ')}
              </p>
            </div>
            <div data-id="element-209">
              <div className="font-bold text-slate-800 mb-2" data-id="element-210">
                Certifications
              </div>
              <ul className="text-slate-600 space-y-1" data-id="element-211">
                {data.certifications.slice(0, 3).map((cert, i) => <li key={i} data-id="element-212">
                    {cert.title} ({cert.year || cert.date})
                  </li>)}
              </ul>
            </div>
          </div>
        </section>
      </div>

      {/* Footer Elements */}
      {showQR && <div className="absolute bottom-12 right-12" data-id="element-213">
          <img src={`https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${encodeURIComponent(data.personalInfo.profileUrl)}&color=1C4370&bgcolor=ffffff`} alt="Profile QR" className="w-20 h-20" data-id="element-214" />
        </div>}

      {showPageNumbers && <div className="absolute bottom-8 left-0 right-0 text-center text-xs text-slate-400 font-sans" data-id="element-215">
          Page 1 of 2
        </div>}
    </div>;
}